<div bsModal #crownAISettingsModal="bs-modal" class="eup-modal modal fade" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">
                    <button logClick id="btn-hide-design-suite-settings" type="button" class="close close-sign" (click)="hide()">
                        <svg class="svg-backButton32 svg-backButton32-dims"></svg>
                    </button>
                    {{ 'CrownAI.DesignSuite' | translate }}
                </h3>
            </div>
            <div class="modal-body">
                <div class="settings-title">{{ 'CrownAI.CrownCalculation' | translate }}</div>
                <eup-generic-slider
                    [label]="'CrownAI.Distance' | translate"
                    [min]="-1.0"
                    [max]="1.0"
                    [step]="0.01"
                    [sliderMin]="'CrownAI.tight' | translate"
                    [sliderMax]="'CrownAI.loose' | translate"
                    [(ngModel)]="distanceToNeighbor"
                    (valueCommitted)="settingChanged('distanceToNeighbor', $event)"
                    [parent]="'DesignSuiteSettings'"
                    [id]="'distanceToAdjacent'">
                </eup-generic-slider>
                <eup-generic-slider
                    [label]="'CrownAI.OcclusalClearance' | translate"
                    [min]="-1.0"
                    [max]="1.0"
                    [step]="0.01"
                    [sliderMin]="'CrownAI.tight' | translate"
                    [sliderMax]="'CrownAI.loose' | translate"
                    [(ngModel)]="distanceToAntagonist"
                    (valueCommitted)="settingChanged('distanceToAntagonist', $event)"
                    [parent]="'DesignSuiteSettings'"
                    [id]="'occlusalClearance'">
                </eup-generic-slider>
                <eup-generic-slider
                    [label]="'CrownAI.Contact-area-size' | translate"
                    [sliderMin]="'0%'"
                    [sliderMax]="'100%'"
                    [(ngModel)]="arealAdjacentContacts"
                    (valueCommitted)="settingChanged('arealAdjacentContacts', $event)"
                    [parent]="'DesignSuiteSettings'"
                    [id]="'contactAreaSize'">
                </eup-generic-slider>
                <eup-generic-slider
                    [label]="'CrownAI.Detail-level' | translate"
                    [min]="-100"
                    [sliderMin]="'CrownAI.smooth' | translate"
                    [sliderMax]="'CrownAI.detailed' | translate"
                    [(ngModel)]="preferSmoothVsDetails"
                    (valueCommitted)="settingChanged('preferSmoothVsDetails', $event)"
                    [parent]="'DesignSuiteSettings'"
                    [id]="'detailLevel'">
                </eup-generic-slider>
                <tlk-select
                    class="crown-ai-list"
                    [label]="'CrownAI.Style' | translate"
                    [pinnedOptions]="crownAIListOptionsPinned"
                    [options]="crownAIListOptions"
                    [ngModel]="style"
                    (ngModelChange)="ngModelChange($event)"
                ></tlk-select>
            </div>
        </div>
    </div>
</div>
